<template>
  <div @click="onClick()" class="cert-home-content-card-parent">
    <div class="cert-home-content-card cert-dark cert-thin">
      <div class="d-flex flex-row">
        <a class="cert-title d-flex" target="_blank" :href="'//'+link">
          <lorem-ipsum v-if="title==null" add="3w" class="mx-auto"></lorem-ipsum>
          <div v-if="title!=null">{{ title }}</div>
          <micon icon="launch" class="my-auto ml-auto"/>
        </a>
      </div>

      <div class="cert-text">
        <div v-if="data!=null">{{ data }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import LoremIpsum from 'vue-lorem-ipsum';

export default {
  name: "CertDataCard",
  props: {
    title: String,
    data: String,
    link: String,
  },
  components: {
    LoremIpsum,
  },
  methods: {
    onClick() {
      this.$router.push({name: `Alert`, params: {id: this.id}})
    }
  }
}
</script>